export default __webpack_public_path__ + "static/media/global-cheers-logo.0a33b969.svg";